import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function PrivacyConsentBanner({ onAccept, onReject }) {
  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 p-3 sm:p-4 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
      data-testid="privacy-consent-banner"
      role="dialog"
      aria-labelledby="privacy-consent-title"
      aria-describedby="privacy-consent-description"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-2xl border border-zinc-800 bg-[#09090b]/95 p-4 shadow-2xl shadow-black/40 backdrop-blur-md sm:p-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="min-w-0 space-y-2">
            <h2
              id="privacy-consent-title"
              className="text-sm font-semibold text-white"
            >
              Sua privacidade importa
            </h2>
            <p
              id="privacy-consent-description"
              className="text-sm leading-relaxed text-zinc-400"
            >
              Utilizamos tecnologias essenciais para o funcionamento do FIVI360
              e, com sua autorização, dados de uso para entender como a
              plataforma é utilizada e melhorar sua experiência.
            </p>
            <Link
              to="/privacidade"
              className="inline-block text-xs text-zinc-500 underline-offset-4 hover:text-zinc-300 hover:underline"
              data-testid="privacy-consent-privacy-link"
            >
              Política de Privacidade
            </Link>
          </div>

          <div className="flex shrink-0 flex-col-reverse gap-2 sm:flex-row sm:items-center">
            <Button
              type="button"
              variant="outline"
              className="h-10 min-w-[8.5rem] border-zinc-700 bg-transparent text-zinc-200 hover:bg-zinc-900 hover:text-white"
              data-testid="privacy-consent-reject"
              onClick={onReject}
            >
              Recusar
            </Button>
            <Button
              type="button"
              className="h-10 min-w-[8.5rem] bg-white text-black hover:bg-zinc-200"
              data-testid="privacy-consent-accept"
              onClick={onAccept}
            >
              Aceitar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
